import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space10 } = theme();

  return StyleSheet.create({
    container: {
      paddingBottom: space10,
      paddingHorizontal: 0,
    },
  });
};

export { style };
